<template>
  <div>
    <Drawer :drawer="drawer" title="装载" :size="920" @close="close">
      <div class="view">
        <div class="sandway">
          <div style="flex: 1">
            <span class="label">派送方式</span>
            <span class="value">
              {{
                rowData.pickUpType === 1
                  ? `${tableData.columns[0]?.typeName}-${tableData.columns[0]?.code}`
                  : "回仓"
              }}
            </span>
            <span
              class="item"
              style="height: 40px; line-height: 40px; margin-left: 8px"
            >
              {{ sumQty }}
              <span class="sufix" style="line-height: 40px">件</span>
            </span>
            <span class="item" style="height: 40px; line-height: 40px">
              {{ sumWeight }}
              <span class="sufix" style="line-height: 40px">KG</span>
            </span>
            <span class="item" style="height: 40px; line-height: 40px">
              {{ sumSquare }}
              <span class="sufix" style="line-height: 40px">CBM</span>
            </span>
          </div>
          <div class="btn" @click="dialogVisible4 = true">
            <i class="el-icon-circle-plus add" />
          </div>
          <div class="btn" style="margin-left: 16px" @click="updateData">
            <i class="el-icon-edit add" />
          </div>
        </div>
        <!-- <div class="upload-area">
          <div class="content">
            <div class="btn" @click="dialogVisible1 = true">选择订单</div>
            <div class="btn" @click="dialogVisible = true">
              <img
                style="vertical-align: middle"
                src="@/assets/images/bill/upload.png"
              />
              导入订单
            </div>
            <div class="btn1" @click="download()">
              <img
                style="vertical-align: middle"
                src="@/assets/images/bill/download.png"
              />
              下载模版
            </div>
          </div>
        </div> -->
        <BaseTable
          style="margin-top: 16px"
          :height="480"
          :tableData="tableData"
          :isPager="false"
          :border="true"
        >
          <template slot="typeName" slot-scope="row">
            {{ row.scope.typeName }}
            {{ row.scope.code ? `- ${row.scope.code}` : "" }}
          </template>
          <template slot="qty" slot-scope="row">
            <span class="item" style="width: 80px">
              {{ row.scope.qty || 0 }}
              <span class="sufix">件</span>
            </span>
            <span class="item">
              {{ row.scope.weight || 0 }}
              <span class="sufix">KG</span>
            </span>
            <span class="item">
              {{ row.scope.square || 0 }}
              <span class="sufix">CBM</span>
            </span>
            <el-button
              type="text"
              size="mini"
              @click="deleteRow(row.scope)"
            >删除</el-button
            >
          </template>
          <template slot="remarks" slot-scope="row">
            <el-popover placement="bottom-end" width="426" trigger="click">
              <img
                v-if="!row.scope.remarks"
                slot="reference"
                style="cursor: pointer"
                src="@/assets/images/bill/edit2.png"
              />
              <img
                v-else
                slot="reference"
                style="cursor: pointer"
                src="@/assets/images/bill/message.png"
              />
              <div class="remark-area">
                <div class="title">
                  <p class="lable">备注内容</p>
                  <p>
                    <span class="copy" @click="handleEdit(row.scope)">
                      <img
                        style="vertical-align: -4px"
                        width="16"
                        height="16"
                        src="@/assets/images/bill/edit2.png"
                      />修改
                    </span>
                    <span class="copy" @click="handleCopy(row.scope.remarks)">
                      <img
                        style="vertical-align: -4px"
                        src="@/assets/images/bill/copy1.png"
                      />复制
                    </span>
                  </p>
                </div>
                <div class="content">
                  {{ row.scope.remarks }}
                </div>
              </div>
            </el-popover>
          </template>
        </BaseTable>
      </div>
      <ExportOrderDialog
        :dialogVisible="dialogVisible"
        :sandwayObj="sandwayObj"
        :rowData="rowData"
        @ok="ok"
        @cancel="dialogVisible = false"
      ></ExportOrderDialog>
      <SelectOrderListDialog
        :dialogVisible="dialogVisible1"
        :sandwayObj="sandwayObj"
        :rowData="rowData"
        @ok="ok"
        @cancel="dialogVisible1 = false"
      >
      </SelectOrderListDialog>
      <OrderDetailDialog
        :dialogVisible="dialogVisible2"
        :orderData="orderData"
        :rowData="rowData"
        :sendWay="sendWay"
        @ok="ok"
        @cancel="dialogVisible2 = false"
      >
      </OrderDetailDialog>
      <EditRemarkDialog
        :dialogVisible="dialogVisible3"
        :editData="editData"
        @ok="ok"
        @cancel="dialogVisible3 = false"
      ></EditRemarkDialog>
      <AddSendwayDialog :dialogVisible="dialogVisible4" :editTableData="editTableData" :rowData="rowData" @ok="dialogVisible4 = false;getSendWay()" @cancel="dialogVisible4 = false; editTableData = []"></AddSendwayDialog>
    </Drawer>
  </div>
</template>

<script>
const Drawer = () => import('@/components/drawer/Drawer')
import ExportOrderDialog from './ExportOrderDialog'
import SelectOrderListDialog from './SelectOrderListDialog'
import EditRemarkDialog from './EditRemarkDialog'
import OrderDetailDialog from './OrderDetailDialog'
import AddSendwayDialog from './AddSendwayDialog'
import {
  getMBLSendWay,
  getOrderDetailPages,
  onLoadMBL,
  searchOnLoadMBLT6,
  deleteMblSendWay
} from '@/api/bill'
const BaseTable = () => import('@/components/table/BaseTable')
import config from '@/utils/config'
// import { update } from 'lodash'
export default {
  components: {
    Drawer,
    ExportOrderDialog,
    SelectOrderListDialog,
    BaseTable,
    OrderDetailDialog,
    EditRemarkDialog,
    AddSendwayDialog
  },
  filters: {
    formatterSendway(name) {
      const item = config.sendWayOptions.find((a) => a.value === name)
      return item?.label
    }
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {
          blNo: 'MATS123124'
        }
      }
    }
  },
  data() {
    return {
      config,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      fileList: [],
      tableData: {
        fileds: [
          {
            filed: 'containerNo',
            label: '柜号',
            width: '150'
          },
          {
            filed: 'typeName',
            label: '处理方式',
            width: '',
            isCustom: true
          },
          {
            filed: 'qty',
            label: '订单件数 - 重量 - 方数',
            width: '380',
            isCustom: true
          },
          {
            filed: 'remarks',
            label: '备注',
            width: '80',
            isCustom: true
          }
        ],
        columns: [],
        total: 0,
        spanMethod: ({ row, column, rowIndex, columnIndex }) => {
          console.log(row, column, rowIndex, columnIndex)
          if (columnIndex === 0) {
            const rowMuti = []
            const index = this.tableData.columns.findIndex(
              (a) => a.typeName + a.code === row.typeName + row.code
            )
            if (index === rowIndex) {
              // 如果第一次出现
              for (let i = rowIndex; i < this.tableData.columns.length; i++) {
                if (
                  this.tableData.columns[i].typeName +
                    this.tableData.columns[i].code ===
                  row.typeName + row.code
                ) {
                  rowMuti.push(this.tableData.columns[i])
                } else {
                  break
                }
              }
            }
            if (rowMuti.length > 0) {
              return {
                rowspan: rowMuti.length || 1,
                colspan: 1
              }
            } else {
              if (
                rowIndex === this.tableData.columns.length - 1 &&
                rowMuti.length === 0 &&
                index === rowIndex
              ) {
                return {
                  rowspan: 1,
                  colspan: 1
                }
              } else {
                return {
                  rowspan: 0,
                  colspan: 0
                }
              }
            }
          }
        }
      },
      orderList: [],
      orderData: [],
      sendWay: 0,
      editData: {},
      editTableData: []
    }
  },
  computed: {
    sandwayObj() {
      if (this.rowData.pickUpType === 1) {
        return this.tableData.columns[0]
      } else {
        return {}
      }
    },
    sumQty() {
      let sum = 0
      this.tableData.columns.forEach((a) => {
        sum += a.qty
      })
      return sum
    },
    sumWeight() {
      let sum = 0
      this.tableData.columns.forEach((a) => {
        sum += a.weight
      })
      return sum.toFixed(2)
    },
    sumSquare() {
      let sum = 0
      this.tableData.columns.forEach((a) => {
        sum += a.square
      })
      return sum.toFixed(2)
    }
  },
  watch: {
    drawer(val) {
      if (val) {
        this.getSendWay()
      }
    }
  },
  methods: {
    async getSendWay() {
      try {
        const res = await getMBLSendWay({
          mblId: this.rowData.id
        })
        if (res.success) {
          const data = res.data.sort((a, b) => {
            if (a.type === b.type) {
              if (a.code && b.code) {
                return (
                  parseInt(a.code.split(' ')[1], 10) -
                  parseInt(b.code.split(' ')[1], 10)
                )
              } else {
                return a.type - b.type
              }
            } else {
              return a.type - b.type
            }
          })
          this.tableData.columns = data
          if (res.data.length > 0) {
            this.getOrderList()
          }
        } else {
          this.$message.error(res.errorMessage)
        }
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    async getOrderList() {
      try {
        const res = await getOrderDetailPages({
          pageIndex: 1,
          pageSize: 10000,
          queryParam: {
            id: this.rowData.id
          }
        })
        if (res.success) {
          this.orderList = res.data.list
        }
      } catch (error) {
        console.log(error)
      }
    },
    ok() {
      this.getSendWay()
      this.dialogVisible2 = false
      this.dialogVisible = false
      this.dialogVisible1 = false
      this.dialogVisible3 = false
    },
    download() {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      const guid = 'cd4e9875f01a4b41ba8860c6150f6dbb'
      elink.href = `/api/SystemFile/downLoadTemplate?guid=${guid}`
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    },
    close() {
      this.$emit('close')
    },
    detail(row) {
      console.log(row)
      const orderData = this.orderList.filter((a) => a.mblSendWayId === row.id)
      this.orderData = orderData
      this.sendWay = row.type
      this.dialogVisible2 = true
    },
    handleEdit(row) {
      this.editData = row
      this.dialogVisible3 = true
    },
    // 提示内容复制
    handleCopy(val) {
      const url = val
      const oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;

      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      })
      oInput.remove()
    },
    async t6() {
      try {
        const params = {
          mblId: this.rowData?.id,
          operation: 2,
          orderItems: []
        }
        this.orderList.forEach((item) => {
          params.orderItems.push({
            orderId: item.id,
            trackingNumber: item.trackingNumber
          })
        })
        const res = await onLoadMBL(params)
        if (res.success) {
          const res1 = await searchOnLoadMBLT6({ number: this.rowData.blNo })
          if (res1.success) {
            // this.$message.error('无订单数据')
          } else {
            this.$message.error(res1.errorMessage)
          }
        } else {
          this.$message.error(res.errorMessage)
        }
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    updateData() {
      this.dialogVisible4 = true
      this.editTableData = this.tableData.columns
    },
    deleteRow(row) {
      this.$confirm('此操作将删除该派送方式, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      })
        .then(() => {
          deleteMblSendWay({
            mblSendWayId: row.id
          }).then((res) => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getSendWay()
            } else {
              this.$message.error(res.errorMessage)
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.view {
  width: calc(100% - 80px);
  height: calc(100% - 48px);
  margin: 24px auto;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  .title {
    width: 36px;
    height: 24px;
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #25396f;
    line-height: 24px;
  }
  .sandway {
    margin-top: 24px;
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    .label {
      width: 56px;
      height: 40px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #25396f;
      line-height: 40px;
    }
    .value {
      display: inline-block;
      width: 150px;
      height: 40px;
      background: #f8fbff;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      margin-left: 8px;
      font-size: 14px;
      font-weight: 400;
      color: #25396f;
      line-height: 40px;
      text-indent: 16px;
    }
    .btn {
      width: 60px;
      height: 40px;
      background:  rgb(18,88,188);
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      font-size: 24px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
  }
  .upload-area {
    width: 705px;
    height: 120px;
    background: #f8fbff;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    border: 1px dashed #dbe4f2;
    margin: 16px auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .content {
      display: flex;
      .btn {
        width: 160px;
        height: 40px;
        background:  rgb(18,88,188);
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
        cursor: pointer;
        text-align: center;
        margin-left: 16px;
      }
      .btn1 {
        width: 160px;
        height: 38px;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid  rgb(18,88,188);
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color:  rgb(18,88,188);
        line-height: 38px;
        cursor: pointer;
        text-align: center;
        margin-left: 16px;
      }
    }
  }
  .detail {
    color:  rgb(18,88,188);
    margin-left: 20px;
    cursor: pointer;
  }
  .item {
    display: inline-block;
    width: 100px;
    height: 28px;
    background: #f2f7ff;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    position: relative;
    font-size: 14px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    color: #25396f;
    line-height: 28px;
    text-indent: 8px;
    text-align: left;
    & + .item {
      margin-left: 8px;
    }
    & .sufix {
      position: absolute;
      right: 8px;
      font-size: 14px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #7c8db5;
      line-height: 28px;
    }
  }
}

.remark-area {
  margin: 8px auto;
  width: 400px;
  height: 200px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #eeeeee;
  .title {
    width: 400px;
    height: 39px;
    background: #f7f7f7;
    border-radius: 4px 4px 0px 0px;
    opacity: 1;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: space-between;
    .lable {
      margin-left: 20px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 39px;
    }
    .copy {
      margin-right: 20px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color:  rgb(18,88,188);
      line-height: 39px;
      cursor: pointer;
    }
  }
  .content {
    padding: 14px 20px;
    width: 360px;
    max-height: 132px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    overflow-y: auto;
  }
}
</style>
